import React from 'react';
import { Datagrid, DeleteButton, EditButton, List, TextField, DateField } from 'react-admin';
import DuplicateButton from '../../../commonComponents/DuplicateButton';
import CustomListActions from '../../../commonComponents/ListActions/CustomListActions';
import StatusField from '../../../commonComponents/StatusField';
import { duplicateRecord } from '../../../helpers/duplicateQuiz';
import QuizFilter from './QuizFilter';

const QuizzesList = (props) => (
  <List
    title="Quizzes"
    filters={<QuizFilter />}
    exporter={false}
    actions={<CustomListActions />}
    bulkActionButtons={false}
    sort={{ field: 'id', order: 'DESC' }}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField label="Name" source="name" />
      <TextField label="Topic" source="brand.name" />
      <StatusField label="Status" source="status" />
      <TextField label="Price" source="price" />
      <DateField label="Publish date" source="published_at" />
      <EditButton />
      <DuplicateButton copyRecord={duplicateRecord} />
      <DeleteButton undoable={false} />
    </Datagrid>
  </List>
);

export default QuizzesList;
